<template>
<!--  <b-row :id="rowData.uid" :data-h="rowData.height" :style="getRowsStyle">-->
    <div class="row justify-content-center" :id="rowData.uid" :data-h="rowData.height" :style="getRowsStyle">
    <div class="float_btn top" v-show="btnId === rowData.uid && !isBigScreenPreview()">
      <div @mousedown="updateSizeStart($event, 'top')" class="btn_border icon-portal-up_bold"></div>
    </div>
    <div class="float_btn bottom" v-show="btnId === rowData.uid && !isBigScreenPreview()">
      <div @mousedown="updateSizeStart($event, 'bottom')" class="btn_border icon-portal-down_bold"></div>
    </div>
    <stage-col
      :btnId="btnId"
      :pageId="pageId"
      :zoom="zoom"
      v-for="col in rowData.cols"
      :id="col.uid"
      :key="col.uid"
      :colData="col"
      @contextmenuHandle="contextmenuHandle"
    />
    </div>
<!--  </b-row>-->
</template>
<script>
import { handleFindLayoutStageOptionsByUid, _throttle } from "utils"

export default {
  props: {
    rowData: {
      type: Object
    },
    pageId: {
      type: String
    },
    btnId: {
      type: String | undefined
    },
    zoom: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      start: null,
      dragging: false,
      type: null
    }
  },
  computed: {
    getRowsStyle() {
      return Object.assign({
        position: "relative",
        height: this.rowData.height,
        marginLeft: "0",
        marginRight: "0",
        border: this.isBigScreenPreview()
          ? "none"
          : this.btnId === this.rowData.uid
          ? "1px solid rgb(184 0 255)"
          : "none"
      })
    }
  },
  methods: {
    contextmenuHandle(e) {
      this.$emit("contextmenuHandle", e)
    },
    updateSizeStart(e, type) {
      this.type = type
      this.dragging = true
      this.start = e.screenY
      window.addEventListener("mousemove", this.updateSizeEnd)
      window.addEventListener("mouseup", this.dragendEv)
    },
    dragendEv() {
      this.dragging = false
      window.removeEventListener("mousemove", this.updateSizeEnd)
      window.removeEventListener("mouseup", this.dragendEv)
    },
    //顶部按钮结束后 处理row高度的函数
    //计算原理:在鼠标按下时记住当前鼠标在screen中的位置,在鼠标抬起时计算鼠标改变的比例
    updateSizeEnd: _throttle(function (e) {
      if (!this.dragging) return
      const bottom = (e.screenY - this.start) / this.zoom
      const top = (this.start - e.screenY) / this.zoom
      const res = { top, bottom }
      const elH = this.$el.offsetHeight
      const hPercent = Number((res[this.type] / elH).toFixed(2)) //计算拖拽后的高度变化的比例,然后改变当前布局框大小
      const options = this.$store.state[this.request_prefix].page.layoutOption.rows
      let find = {}
      handleFindLayoutStageOptionsByUid(options, this.rowData.uid, find)
      const { data, index } = find
      const tar = data[index] //当前正在拖拽的布局框
      let prev //兄弟布局框,拖拽的前面的按钮应该改变上一个兄弟布局框,反之更改后一个兄弟布局框的大小
      if (this.type === "top") {
        //如果当前行不是第一个，就返回当前行的上一个；  如果当前行是第一个，并且当前行的父级内不止一行
        prev = index ? data[index - 1] : data[index + 1] || tar.log("prev", prev)
      } else {
        //如果当前行不是第一个，就返回当前行的上一个；  如果当前行是第一个，并且当前行的父级内不止一行
        prev = index ? data[index + 1] || data[index - 1] : data[index + 1] || tar
      }
      if (prev === tar) return //说明当前行的父级就只有当前行 只是后拖拽高度无意义 直接跳出
      const tarH = (Number(tar.height.slice(0, -1)) * (1 + hPercent)).toFixed(1) + "%" //当前组件的真实高度
      //需要改变的兄弟组件的真实高度
      const prevH =
        (Number(tar.height.slice(0, -1)) - Number(tarH.slice(0, -1)) + Number(prev.height.slice(0, -1))).toFixed(1) +
        "%"
      if (Number(tarH.slice(0, -1)) >= 100 || Number(prevH.slice(0, -1)) <= 1) return
      this.$store.dispatch(this.request_prefix + "/changeStageLayoutOption", {
        uid: tar.uid,
        key: "height",
        value: tarH
      })
      this.$store.dispatch(this.request_prefix + "/changeStageLayoutOption", {
        uid: prev.uid,
        key: "height",
        value: prevH
      })
      this.start = e.screenY
    }, 50)
  }
}
</script>
<style scoped>
.float_btn {
  position: absolute;
  font-size: 20px;
  display: flex;
  justify-content: center;
  text-align: center;
  z-index: 999;
}
.top {
  top: -15px;
}
.bottom {
  bottom: -15px;
}
.btn_border {
  line-height: 150%;
  width: 30px;
  height: 30px;
  background-color: var(--themeColor);
  border-radius: 50%;
}
</style>
